import Image from "components/Elements/Image/Image.tsx";
import LoginForm from "components/Reusable/LoginForm/index.tsx";
import useOrganization from "hooks/useOrganization.ts";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { SocialMediaAuthentication } from "../SocialMediaAuthentication/SocialMediaAuthentication.js";
import { memo } from "react";

export const LoginSection = memo(
  ({
    callback,
    email,
    addSubUserToOrganization,
    completeAddSubUser,
    asRootUser,
    orgLogo,
  }) => {
    const { getTextByKey } = useContent();
    const { checkCurrDomainIsOrgDomain } = useOrganization();

    return (
      <div className="login-section">
        {asRootUser && orgLogo ? (
          <Image className="title-image" src={orgLogo} title="" alt="" />
        ) : (
          <Image
            className="title-image"
            name="jumbomail-M-logo-gray"
            title=""
            alt=""
          />
        )}
        <div className="title">
          {asRootUser
            ? getTextByKey("sign-in-as-root-user")
            : getTextByKey("sign-in")}
        </div>
        <LoginForm
          email={email}
          addSubUserToOrganization={addSubUserToOrganization}
          completeAddSubUser={completeAddSubUser}
          asRootUser={asRootUser}
          callback={callback}
        />
        {!checkCurrDomainIsOrgDomain() ? (
          <>
            <div className="horizontal-or-divider">{getTextByKey("or")}</div>
            <SocialMediaAuthentication
              completeAddSubUser={completeAddSubUser}
              completeAddSubUserByLink={addSubUserToOrganization}
            />
          </>
        ) : null}
      </div>
    );
  }
);
